import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { SelectorOptions } from '../selector-options';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatChipGrid } from '@angular/material/chips';
import { CreateElement } from '../create-element.model';
@Component({
    selector: 'app-selector-chips-tabs',
    templateUrl: './selector-chips-tabs.component.html',
    styleUrls: ['./selector-chips-tabs.component.scss'],
    standalone: false
})
export class SelectorChipsTabsComponent implements OnInit {
  optionsFormGroup: FormGroup;
  visible = true;
  selectable = true;
  removable = true;
  @Input() hasEdit = false;
  @Input() hasUpdate = false;
  @Input() set optionsListTag(x) {
    this.checkAndAddOption(x);
  }
  addOnBlur = true;
  isOverlayClosed = true;
  @ViewChild('selectorChipsTabs', { static: false }) selectorTabs: ElementRef;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  optionsList: any[] = [];
  maxOptionsToShow = 3;
  @Input() selectorOptions: SelectorOptions;
  @Input() selectorGeneralOptions: SelectorOptions;
  @Input() title: string;
  @Input() isValid: boolean;
  @Input() textField = 'text';
  @Input() idField = 'id';
  @Input() createElement: CreateElement;
  @Input() readonly: boolean;
  @Input() _module: string;
  @Input() excludedMediaType: string;
  @Input() mediaType: string[];
  @Input() locationId: number;
  @Input() version: boolean;
  @Output() changedOptions: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() editChip: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('chipGrid') chipGrid: MatChipGrid;
  constructor(
    private readonly formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.getFormChips();
  }

  getFormChips() {
    this.optionsFormGroup = this.formBuilder.group({
      optionsControls: [this.optionsList]
    });
  }

  showAllOptions() {
    this.maxOptionsToShow = this.optionsList.length;
  }

  checkAndAddOption(options: Array<any>) {
    const filteredResults = options.filter(
      (element) => this.optionsList.some(option => option.text === element.text) ? null : element
    );
    this.optionsList = this.optionsList.concat(filteredResults);
  }

  onAddOption(event: any) {
    this.getFormChips();
    if (event.length === undefined) {
      this.processObject(event);
    }
    else {
      event.forEach(tag => {
        this.processObject(tag);
      });
    }
  }

  processObject(event) {
    if (this.optionsList.length === 0) {
      this.addAndEmitOptions(event);
    }
    else {
      const found = this.optionsList
        .find(option => {
          let sameId = false;
          let sameText = false;
          if (option[this.idField] !== undefined) {
            sameId = option[this.idField] === event[this.idField];
          }
          if (option[this.textField] !== undefined) {
            sameText = option[this.textField] === event[this.textField];
          }
          return sameId || sameText;
        });
      if (found) {
        return;
      }
      if (this.optionsList.find(e => e.publicId !== undefined && event.publicId !== undefined)) {
        this.optionsList = this.optionsList.filter(e => e.publicId === undefined);
      }
      this.addAndEmitOptions(event);
    }
    this.maxOptionsToShow = 3;
  }

  private addAndEmitOptions(event: any) {
    if (event.length === undefined) {
      if (event.publicId !== undefined) {
        this.optionsList.unshift(event);
      } else {
        this.optionsList.push(event);
      }
    } else {
      event.forEach((tag) => {
        this.optionsList.push(tag);
      });
    }
    this.changedOptions.emit(this.optionsList);
    this.chipGrid.errorState = false;
    this.optionsFormGroup.controls.optionsControls.setValue(this.optionsList);
  }

  removeOption(event: any) {
    const index = this.optionsList.indexOf(event);
    if (index >= 0) {
      this.optionsList.splice(index, 1);
    }
    if (this.optionsList.length === 0) {
      this.chipGrid.errorState = true;
      this.optionsFormGroup.controls.optionsControls.setValue('');
    }
    this.changedOptions.emit(this.optionsList);
    this.maxOptionsToShow = 3;
  }

  onEditChip(option) {
    this.editChip.emit(option.id);
  }

  getOptionText(option: any): string {
    let text: string;
    Object.entries<string>(option).forEach(([key, value]) => {
      if (key === this.textField) {
        text = value;
      }
    });
    return text;
  }
}
